export const NAV_ITEMS = [
    { text: "خانه", link: "/" },
    { text: "نقشه", link: "/map" },
    { text: "بلاگ", link: "/blog" },
    { text: "تماس", link: "/contactus" }
];
